/* eslint-disable */
const zone = ZONE;
const isOnline = BUILD_VERSION;
import { initTea } from "./inlined-tea";

export function initDataFinder() {
  initTea(window, 'collectEvent');
  window.collectEvent('init', {
    app_id: zone === 'cn' ? 207653 : 209484,
    channel: zone,
    log: true,
    autotrack: true,
  });
  window.collectEvent('start');
}

export const setDataFinderUserInfo = (userInfo: any = {}) => {
  const { staffId = '', name = '' } = userInfo || {};
  const uuid = String(staffId);
  window.collectEvent('config', {
    evtParams: {
      user_name: name,
      user_id: uuid,
    },
    user_unique_id: uuid,
    _staging_flag: 0,
  });
};

export const sendPv = (urlPath: string) => {
  window.collectEvent('predefine_pageiew', {
    // eslint-disable-next-line @typescript-eslint/camelcase
    url_path: urlPath,
    url: `${window.location.origin}${urlPath}`,
  });
};
